import * as React from "react";
import { Context } from "./_context";
export const NavigationCardIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 2.5A3.5 3.5 0 0 1 23.5 6v12a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 18V6A3.5 3.5 0 0 1 4 2.5h16Zm-16 3a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h16a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5H4Zm6.75 3a.25.25 0 0 1 .25.25v2.5a.25.25 0 0 1-.25.25h-3.5a.25.25 0 0 1-.25-.25v-2.5a.25.25 0 0 1 .25-.25h3.5Z", fill: "currentColor" }));
  return iconset[size];
};
NavigationCardIcon.iconId = "XvXH5y";
